import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=2bcb6988&"
import script from "./SurveyForm.vue?vue&type=script&lang=ts&"
export * from "./SurveyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports